<span class="tt-detail-label">{{ label }}</span>
<p *ngIf="hasValue; else projected" class="tt-detail-value">{{ formatted }}</p>
<ng-template #projected>
  <div class="tt-detail-value">
    <ng-content></ng-content>
  </div>
</ng-template>
